import Container, { Service } from 'typedi';
import { SmartBannerService } from './smart.banner.service';
import { LoggerProvider } from '../logger';
import { FeatureAvailabilityToken, UserContextToken, WindowToken } from '../../injection-tokens';
import { IUserContext } from '../user-context/user-context-interface';
import { Features, SmartBannerNotRequiredFtdBrands } from '../../models/enums/general-enums';
import { Utils } from '../utils';
import { IFeatureAvailability } from '../feature/feature-availability/feature-availability-interface';
import { ILogger } from '@sparkware/uc-sdk-core';

@Service()
export class SmartBannerController {
    private readonly _window: Window;
    private readonly _logger: ILogger;
    private readonly _smartBannerService: SmartBannerService;
    private readonly _userContext: IUserContext;
    private readonly _utils: Utils;
    private readonly _featureAvailability: IFeatureAvailability;

    constructor() {
        this._window = Container.get(WindowToken);
        this._logger = Container.get(LoggerProvider).getLogger('SmartBannerController');
        this._smartBannerService = Container.get(SmartBannerService);
        this._userContext = Container.get(UserContextToken);
        this._utils = Container.get(Utils);
        this._featureAvailability = Container.get(FeatureAvailabilityToken);
    }

    public registerSmartBannerService(): void {
        const isSmartBannerEnabled = this._isSmartBannerEnabled();
        if (isSmartBannerEnabled) {
            this._smartBannerService.addSmartBannerFeature();
        } else {
            this._logger.debug('Smart Banner is not enabled, not initialising');
        }
    }

    private _isSmartBannerEnabled(): boolean {
        const isMobile = this._window.pageContextManager.getDeviceData().isMobile;
        const { isFtd } = this._window.pageContextManager.getUserData();
        const smartBannerEnabled = this._featureAvailability.FeatureIsEnabled(
            Features.SMART_BANNER,
        );
        return (
            smartBannerEnabled &&
            ((this._userContext.IsAuthenticated && isFtd) || this._isSmartBannerNotRequiredFtd()) &&
            isMobile &&
            !this._utils.findIfIsNative()
        );
    }

    private _isSmartBannerNotRequiredFtd = (): boolean => {
        const { brandId } = this._window.pageContextManager.getBrandData();
        return !!SmartBannerNotRequiredFtdBrands.find((brand) => brand === brandId);
    };
}
